<template>
	<div class="canvas-opened">
		<div class="dark-mark"></div>
		<div class="box fadeInDown animated">
			<div style="position: relative;padding: 2rem;">
				<div style="margin-top: 2rem;font-size: 1.4rem;font-weight: 500;color: #000;">Member benefits</div>
				<div style="margin-top: 1rem;font-size: 0.8rem;font-weight: 500;color: #06645C;">GCI is a global nursing information platform for precise users in the global nursing industry. This service is exclusive to members.</div>
				
				<div style="display: flex;margin-top: 1.5rem;font-size: 0.7rem;" class="box1">
					<div style="display: flex;align-items: center;width: 100%;margin-right: 1rem;">
						<img src="../assets/imgs/user/userlevel/tick_selected-icon.svg" style="width: 1.5rem;height: 1.5rem;margin-right: 0.2rem;">Browse Service Providers
					</div>
					<div style="display: flex;align-items: center;width: 100%;margin-right: 1rem;">
						<img src="../assets/imgs/user/userlevel/tick_selected-icon.svg" style="width: 1.5rem;height: 1.5rem;margin-right: 0.2rem;">Release requirements
					</div>
					<div style="display: flex;align-items: center;width: 100%;">
						<img src="../assets/imgs/user/userlevel/tick_selected-icon.svg" style="width: 1.5rem;height: 1.5rem;margin-right: 0.2rem;">Browsing requirements
					</div>
				</div>
				
				<div @click="touserlevel" class="btn-cyan-liner" style="width: 100%;height: 2.5rem;display: flex;align-items: center;justify-content: center;margin-top: 2.5rem;cursor: pointer;">Experience Now</div>
				
				<!-- 关闭 -->
				<div style="position: absolute;right: 1rem;top: 1rem;" @click="close()">
					<img src="../assets/imgs/login/close.svg" style="width:1rem;height:1rem;cursor: pointer;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
		export default {
			data() {
				return {
				}
			},
			props:{
				// img:String
			},
			components: {
			},
			filters: {
	        },
			methods: {
				touserlevel(){
					this.$router.push({name:'userlevel'})
					this.close()
				},
				close() {
					this.$bus.$emit('userleveldialog', false)
				},
			},
			mounted() {
			}
		}
</script>

<style lang="scss" scoped>
	.box{
		margin: auto;
		position: fixed;
		top: 0; left: 0; bottom: 0; right: 0;
		width:37rem;height: 20rem;
		border-radius: 1rem;
		
		// background-color: #fff;
		z-index: 999;
		display: flex;flex-direction: column;
		
		background-image: url('../assets/imgs/user/userlevel/userleveldialogbg.png');
		background-repeat: no-repeat;background-size: cover;background-position: center;
	}
	.dark-mark{
		z-index: 999;
		background-color: rgba(0, 0, 0, 0.5);
	}
	@media (min-width:767px) {
		.login-input:hover{
				border:1px solid #000 !important
		}
	}
	@media (max-width:767px) {
		.box{
			width: 90vw;
			height: 25rem;
		}
		.box1{
			flex-direction: column;
		}
	}
</style>